import { BrainCircuit, Cpu, Lock, Radar, ShieldCheck, Code2 } from "lucide-react";
import { useLang } from "../i18n";
import { Reveal, Section, SectionHead } from "./Reveal";

const ICONS = { shield: ShieldCheck, cpu: Cpu, brain: BrainCircuit, lock: Lock, code: Code2, radar: Radar };

export const Pillars = () => {
  const { t } = useLang();

  return (
    <Section id="pilares" className="scanlines bg-ink-900/40">
      <SectionHead label={t.pilares.label} title={t.pilares.heading} sub={t.pilares.sub} />
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {t.pilares.items.map((item, i) => {
          const Icon = ICONS[item.icon] || Radar;
          return (
            <Reveal key={item.id} delay={(i % 3) * 0.07} className="h-full">
              <div
                data-testid={`pillar-card-${item.id.toLowerCase()}`}
                className="group h-full rounded-xl border border-line bg-ink-950/80 p-7 transition-all duration-300 hover:-translate-y-1 hover:border-volt/30 hover:bg-ink-800"
              >
                <div className="flex items-center justify-between">
                  <span className="font-mono text-[11px] tracking-[0.25em] text-volt">{item.id}</span>
                  <Icon size={20} className="text-white/40 transition-colors group-hover:text-volt" />
                </div>
                <h3 className="mt-8 font-display text-xl font-bold tracking-tight">{item.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-mist">{item.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </Section>
  );
};
